import request from "@src/utils/request";

export interface HelpRequestData {
  email: string;
  message: string;
}

export interface HelpRequestResponse {
  id: string;
  email: string;
  message: string;
  created_at: string;
  status: string;
}

export function createUserHelpRequest(
  formData: HelpRequestData,
): Promise<{ body: HelpRequestResponse }> {
  return request().post("/api/v1/user-help-requests/").send(formData);
}
